/* eslint-disable no-nested-ternary */
import React, { createContext, useState, useContext, useEffect } from "react";
import { Snackbar, Alert, Stack, Typography, Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import Iconify from "../components/Iconify";
import LucideIcon from "../components/LucideIcon";

const SnackbarContext = createContext();

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    msg: "",
    isError: false, // Options: "error", "warning", "info", "success"
  });

  const showSnackbar = (msg, isError = null) => {
    setSnackbar({ open: true, msg, isError });
  };

  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const [searchParams] = useSearchParams();
          const [accessToken, setAccessToken] = useState();
      useEffect(() => {
              // Vérifie si un token est déjà stocké
              console.log('////////////////')
              const token = Cookies.get("facebook_access_token")
              
              console.log(token)
              if (token) {
                //
              } else {
                const token = searchParams.get("fb_access_token");
                console.log(token)
                if (token) {
                  Cookies.set(`facebook_access_token`, JSON.stringify(token));
                  setAccessToken(token);
                }
              }
            }, [searchParams]);
  return (
    <SnackbarContext.Provider value={showSnackbar}>
      {children}
      <Snackbar open={snackbar.open}
        autoHideDuration={50000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Stack fullWidth spacing={2} direction={'row'} sx={{ padding: 2, borderRadius: '10px', bgcolor: 'white', alignItems: 'center', border: '1px solid gainsboro', boxShadow: '3px'}}>
          <LucideIcon name={`${snackbar.isError === null ? 'CircleCheck': 'CircleCheck'}`} size={18} color={`${snackbar.isError === null ? 'green': 'red'}`}/>
          <Typography fontSize={12} fontWeight={550} color={'text.primary'}>{snackbar.msg}</Typography>
        </Stack>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => useContext(SnackbarContext);